import React, { useEffect, useState } from "react";
import Grid from '@mui/material/Grid';
import { Typography } from "@mui/material";
import Divider from '@mui/material/Divider';


function About(){

  const [post, setPost] = useState()

  useEffect(() => {
  }, []);


  return (
    <Grid
    container
    spacing={0}
    alignItems="center"
    justifyContent="center"
    sx={{mb: 20}}>
        <Grid item xs={11} sm={9} md={6} >
            <Typography sx={{mb: 2}} variant="h5">
                Disclaimer: This app was not officially created by a university.
            </Typography>
            <Divider sx={{mb: 2, borderBottomWidth: 0.1}} style={{ background: '#CC0633' }} variant="middle" />
            <Typography sx={{mb: 2}} variant="h6">
                This app was created by university students as an open space for students 
                to share their thoughts/confessions and to have fun!
            </Typography>
            <Divider sx={{mb: 2, borderBottomWidth: 0.1}} style={{ background: '#CC0633' }} variant="middle" />
            <Typography sx={{mb: 2}} variant="h6">
                For any support or help, please contact us through this email: universityconfessions0@gmail.com
            </Typography>
        </Grid>
    </Grid>
  );
}

export default About;
